import React, { useState } from 'react';

export default function CollapsiblePanel({ id, title, defaultCollapsed = false, children, headerExtra }) {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div id={id} style={styles.panel}>
      <div style={styles.headerRow}>
        <button style={styles.header} onClick={() => setCollapsed((c) => !c)}>
          <span style={styles.chevron}>{collapsed ? '▸' : '▾'}</span>
          <span style={styles.title}>{title}</span>
        </button>
        {headerExtra}
      </div>
      {!collapsed && <div style={styles.content}>{children}</div>}
    </div>
  );
}

const styles = {
  panel: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    padding: '1.5rem',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  chevron: {
    color: '#6b7280',
    fontSize: '0.85rem',
  },
  title: {
    fontSize: '1rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  content: { marginTop: '1rem' },
};
